import { FindMappingByTypeDataItemDtoTypeEnumKey } from "~/gen/api"
import { useFindMappingByType } from "~/gen/api/hooks"

type QueryProps = {
  page: number
  search: string | undefined
}

export const useFindMappingByTypeQuery = (
  type: FindMappingByTypeDataItemDtoTypeEnumKey,
  queryProps: QueryProps
) => useFindMappingByType(type, queryProps)
